import { render, staticRenderFns } from "./box.vue?vue&type=template&id=a03242ae&scoped=true&"
import script from "./box.vue?vue&type=script&lang=js&"
export * from "./box.vue?vue&type=script&lang=js&"
import style0 from "./box.vue?vue&type=style&index=0&id=a03242ae&lang=scss&scoped=true&"
import style1 from "./box.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a03242ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a03242ae')) {
      api.createRecord('a03242ae', component.options)
    } else {
      api.reload('a03242ae', component.options)
    }
    module.hot.accept("./box.vue?vue&type=template&id=a03242ae&scoped=true&", function () {
      api.rerender('a03242ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/paging/models/box.vue"
export default component.exports